import { render, staticRenderFns } from "./PsEventMain.vue?vue&type=template&id=739763ab&scoped=true&"
import script from "./PsEventMain.vue?vue&type=script&lang=js&"
export * from "./PsEventMain.vue?vue&type=script&lang=js&"
import style0 from "./PsEventMain.vue?vue&type=style&index=0&id=739763ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739763ab",
  null
  
)

export default component.exports